import { tokens } from "../tokens"

// ----------------------------------------------------------------------

const br = {
  [tokens.alerts.attention]: 'Atenção',
  [tokens.alerts.error]: 'Erro',
  [tokens.alerts.success]: 'Sucesso',
  [tokens.alerts.warning]: 'Cuidado',
  [tokens.buttons.accept]: 'Aceitar',
  [tokens.buttons.add]: 'Adicionar',
  [tokens.buttons.addTo]: 'Adicionar ao',
  [tokens.buttons.addToAlt]: 'Adicionar a',
  [tokens.buttons.back]: 'Voltar',
  [tokens.buttons.backHome]: 'Voltar para o Início',
  [tokens.buttons.cancelAndBack]: 'Cancelar e voltar',
  [tokens.buttons.block]: 'Bloquear',
  [tokens.buttons.bulkEdit]: 'Edição em massa',
  [tokens.buttons.bulkStockEntry]: 'Entrada de estoque em massa',
  [tokens.buttons.cancel]: 'Cancelar',
  [tokens.buttons.change]: 'Alterar',
  [tokens.buttons.checkout]: 'Checkout',
  [tokens.buttons.clear]: 'Limpar',
  [tokens.buttons.clearFilter]: 'Limpar filtros',
  [tokens.buttons.close]: 'Fechar',
  [tokens.buttons.create]: 'Criar',
  [tokens.buttons.confirm]: 'Confirmar',
  [tokens.buttons.continue]: 'Continuar',
  [tokens.buttons.delete]: 'Excluir',
  [tokens.buttons.deliver]: 'Confirmar retirada',
  [tokens.buttons.deliverTable]: 'Entregar — {{table}}',
  [tokens.buttons.deliverTableGeneric]: 'Entregar na mesa',
  [tokens.buttons.edit]: 'Editar',
  [tokens.buttons.editLayout]: 'Editar layout',
  [tokens.buttons.filter]: 'Filtrar',
  [tokens.buttons.find]: 'Encontrar',
  [tokens.buttons.finish]: 'Concluir',
  [tokens.buttons.fulfill]: 'Finalizar',
  [tokens.buttons.invite]: 'Convidar',
  [tokens.buttons.new]: 'Novo',
  [tokens.buttons.newAlt]: 'Nova',
  [tokens.buttons.operate]: 'Operar',
  [tokens.buttons.next]: 'Próximo',
  [tokens.buttons.pay]: 'Pagar',
  [tokens.buttons.prepare]: 'Preparar',
  [tokens.buttons.previous]: 'Anterior',
  [tokens.buttons.print]: 'Imprimir',
  [tokens.buttons.reconnect]: 'Reconectar',
  [tokens.buttons.rememberAcc]: 'Lembrar conta',
  [tokens.buttons.record]: 'Gravar',
  [tokens.buttons.resendCodeEmail]: 'Reenviar código',
  [tokens.buttons.resendInvite]: 'Reenviar convite',
  [tokens.buttons.resendVerifEmail]: 'Reenviar e-mail de verificação',
  [tokens.buttons.save]: 'Salvar',
  [tokens.buttons.search]: 'Buscar',
  [tokens.buttons.select]: 'Selecionar',
  [tokens.buttons.setReady]: 'Pronto para retirar',
  [tokens.buttons.setReadyTable]: 'Pronto para levar',
  [tokens.buttons.show]: 'Exibir',
  [tokens.buttons.showMore]: 'Exibir mais',
  [tokens.buttons.submit]: 'Enviar',
  [tokens.buttons.sync]: 'Sincronizar',
  [tokens.buttons.update]: 'Atualizar',
  [tokens.buttons.upload]: 'Carregar',
  [tokens.buttons.validate]: 'Validar',
  [tokens.buttons.validateCheckin]: 'Validar Entrada',
  [tokens.buttons.validateCheckout]: 'Validar Saída',
  [tokens.buttons.useCodeInstead]: 'Usar código',
  [tokens.buttons.verify]: 'Verificar',
  [tokens.buttons.view]: 'Ver',
  [tokens.buttons.viewQR]: 'Visualizar QR Code',
  [tokens.calendar.day]: 'Dia',
  [tokens.calendar.week]: 'Semana',
  [tokens.calendar.month]: 'Mês',
  [tokens.calendar.year]: 'Ano',
  [tokens.charts.activeSale]: 'Promoções Ativas',
  [tokens.charts.averagePublic]: 'Média de Público',
  [tokens.charts.averageTicket]: 'Ticket Médio',
  [tokens.charts.monthlyComparison]: '{{ value }} que o mês passado',
  [tokens.charts.publicDistribution]: 'Distribuição de Público',
  [tokens.charts.publicAgeDistribution]: 'Faixa Etária de Público este',
  [tokens.charts.saleIncome]: 'Receita Promoções',
  [tokens.charts.salesOverview]: 'Visão Geral de Vendas',
  [tokens.charts.salesPerVenue]: 'Vendas por Estabelecimento',
  [tokens.charts.productSalesPerCategory]: 'Produtos Vendidos por Categoria',
  [tokens.charts.productSalesRanking]: 'Produtos Mais Vendidos',
  [tokens.charts.weeklyComparison]: '{{ value }} que a semana passada',
  [tokens.charts.entranceFeeIncome]: 'Receita de Entrada',
  [tokens.charts.entranceFeePerWeekday]: 'Entrada por Dia da Semana',
  [tokens.charts.entranceFeePerVenue]: 'Entrada por Estabelecimento',
  [tokens.charts.entranceFeeParticipants]: 'Participantes com entrada',
  [tokens.charts.entranceFeeAverage]: 'Entrada média por participante',
  [tokens.common.all]: 'Todos',
  [tokens.common.allDone]: 'Tudo feito por aqui',
  [tokens.common.allowed]: 'Permitido',
  [tokens.common.authorized]: 'Autorizado',
  [tokens.common.browse]: 'Navegar',
  [tokens.common.bulk]: 'Em massa',
  [tokens.common.date]: 'Data',
  [tokens.common.dense]: 'Compacto',
  [tokens.common.entry]: 'Entrada',
  [tokens.common.exit]: 'Saída',
  [tokens.common.history]: 'Histórico',
  [tokens.common.languageChanged]: 'Idioma alterado',
  [tokens.common.loss]: 'Perda',
  [tokens.common.maxSize]: 'Tamanho máximo',
  [tokens.common.me]: 'Eu',
  [tokens.common.notAllowed]: 'Não permitido',
  [tokens.common.noData]: 'Nenhum dado encontrado',
  [tokens.common.notes]: 'Notas',
  [tokens.common.or]: 'ou',
  [tokens.common.question]: 'Dúvida',
  [tokens.common.recommended]: 'Recomendado',
  [tokens.common.selected]: 'Selecionado',
  [tokens.common.source]: 'Origem',
  [tokens.common.to]: 'para',
  [tokens.common.unauthorized]: 'Desautorizado',
  [tokens.common.with]: 'com',
  [tokens.components.fileUpload.header]: 'Carregar arquivo',
  [tokens.components.fileUpload.subStart]: 'Arraste aqui o arquivo ou clique para',
  [tokens.components.fileUpload.subEnd]: 'do seu computador',
  [tokens.components.photoUpload.header]: 'Carregar fotos',
  [tokens.components.photoUpload.subStart]: 'Arraste aqui as fotos ou clique para',
  [tokens.components.photoUpload.subEnd]: 'do seu computador',
  [tokens.components.filter]: 'Filtros',
  [tokens.components.search]: 'Buscar',
  [tokens.components.qrCode]: 'Código QR',
  [tokens.components.validatingQrCode]: 'Validando QR Code...',
  [tokens.components.photo]: 'Foto',
  [tokens.controls.created_at]: 'Criado em',
  [tokens.controls.created_by]: 'Criado por',
  [tokens.controls.orderHistory]: 'Histórico do pedido',
  [tokens.controls.tabHistory]: 'Histórico da comanda',
  [tokens.controls.updated_at]: 'Atualizado em',
  [tokens.controls.updated_by]: 'Atualizado por',
  [tokens.fields.address]: 'Endereço',
  [tokens.fields.addressProof]: 'Comprovante de Endereço',
  [tokens.fields.amount]: 'Valor',
  [tokens.fields.area]: 'Área',
  [tokens.fields.bankingProof]: 'Comprovante Bancário',
  [tokens.fields.birthDate]: 'Data de Nascimento',
  [tokens.fields.categoryCode]: 'Código da categoria',
  [tokens.fields.categorySku]: 'SKU da categoria',
  [tokens.fields.city]: 'Cidade',
  [tokens.fields.code]: 'Código',
  [tokens.fields.comment]: 'Comentário',
  [tokens.fields.complement]: 'Complemento',
  [tokens.fields.companyContract]: 'Contrato Social',
  [tokens.fields.cost]: 'Custo',
  [tokens.fields.country]: 'País',
  [tokens.fields.description]: 'Descrição',
  [tokens.fields.discount]: 'Desconto',
  [tokens.fields.districtCode]: 'Código Municipal',
  [tokens.fields.districtId]: 'Inscrição Municipal',
  [tokens.fields.drinks]: 'Bebida',
  [tokens.fields.email]: 'E-mail',
  [tokens.fields.entrance_fee]: 'Valor de Entrada',
  [tokens.fields.federalId]: 'CNPJ',
  [tokens.fields.federalIdCard]: 'Cartão CNPJ',
  [tokens.fields.firstName]: 'Nome',
  [tokens.fields.fiscalRegime]: 'Regime Tributário',
  [tokens.fields.from]: 'De',
  [tokens.fields.food]: 'Comida',
  [tokens.fields.govId]: 'CPF',
  [tokens.fields.gender]: 'Gênero',
  [tokens.fields.item]: 'Item',
  [tokens.fields.lastName]: 'Sobrenome',
  [tokens.fields.legalName]: 'Razão Social',
  [tokens.fields.manager]: 'Responsável',
  [tokens.fields.min_amount]: 'Pedido Mínimo',
  [tokens.fields.name]: 'Nome',
  [tokens.fields.notVerified]: 'Não verificado',
  [tokens.fields.number]: 'Número',
  [tokens.fields.openStatus]: 'Funcionamento',
  [tokens.fields.password]: 'Senha',
  [tokens.fields.paymentMethod]: 'Método de Pagamento',
  [tokens.fields.payment_mode]: 'Modo de Pagamento',
  [tokens.fields.paymentStatus]: 'Status Pagamento',
  [tokens.fields.placeholders.description]: 'Breve descrição do seu estabelecimento que ficará disponível para os seus clientes...',
  [tokens.fields.placeholders.searchAddress]: 'Digite rua, número ou CEP',
  [tokens.fields.phone]: 'Telefone',
  [tokens.fields.price]: 'Preço normal',
  [tokens.fields.productCode]: 'Código do produto',
  [tokens.fields.productNcm]: 'NCM do produto',
  [tokens.fields.productSku]: 'SKU do produto',
  [tokens.fields.profileAvatar]: 'Foto do Perfil',
  [tokens.fields.quantity]: 'Quantidade',
  [tokens.fields.saleprice]: 'Preço promocional',
  [tokens.fields.sale]: 'Promoção',
  [tokens.fields.service_mode]: 'Modo de atendimento',
  [tokens.fields.sku]: 'SKU',
  [tokens.fields.stock]: 'Estoque',
  [tokens.fields.stockQuantity]: 'Quantidade em estoque',
  [tokens.fields.stock_threshold]: 'Estoque mínimo',
  [tokens.fields.state]: 'Estado',
  [tokens.fields.stateId]: 'Inscrição Estadual',
  [tokens.fields.status]: 'Situação',
  [tokens.fields.street]: 'Rua',
  [tokens.fields.subtotal]: 'Subtotal',
  [tokens.fields.tableNumber]: 'Número da Mesa',
  [tokens.fields.capacity]: 'Capacidade',
  [tokens.fields.tabId]: 'Número da Comanda',
  [tokens.fields.taxes]: 'Taxa de serviço',
  [tokens.fields.tip]: 'Gorjeta',
  [tokens.fields.to]: 'Até',
  [tokens.fields.total]: 'Total',
  [tokens.fields.netAmount]: 'Líquido estimado',
  [tokens.fields.processorFee]: 'Taxa cartão (3,99%)',
  [tokens.fields.platformCommission]: 'Comissão Check',
  [tokens.fields.underVerification]: 'Em verificação',
  [tokens.fields.unitCost]: 'Custo unitário',
  [tokens.fields.unitPrice]: 'Preço unitário',
  [tokens.fields.verified]: 'Verificado',
  [tokens.fields.venueType]: 'Segmento',
  [tokens.fields.weekday]: 'Dia da Semana',
  [tokens.fields.zipCode]: 'Código Postal',
  [tokens.gender.female]: 'Mulher',
  [tokens.gender.male]: 'Homem',
  [tokens.gender.other]: 'Outro',
  [tokens.gender.unidentified]: 'Não identificado',
  [tokens.helper.higherThan]: '{{ field }} deve ser maior que {{ value }}',
  [tokens.helper.invalid]: 'É inválido',
  [tokens.helper.invalidDate]: 'A data precisa ser válida',
  [tokens.helper.invalidEmail]: 'O endereço de e-mail precisa ser válido',
  [tokens.helper.invalidGovId]: 'CNPJ inválido',
  [tokens.helper.isRequired]: 'é obrigatório',
  [tokens.helper.lowerThan]: '{{ field }} deve ser menor que {{ value }}',
  [tokens.helper.minChar]: '{{ field }} precisa ter no mínimo {{ count }} caracteres',
  [tokens.helper.minLower]: '{{ field }} precisa ter no mínimo {{ count }} letra minúscula',
  [tokens.helper.minNumber]: '{{ field }} precisa ter no mínimo {{ count }} número',
  [tokens.helper.minSymbol]: '{{ field }} precisa ter no mínimo {{ count }} caracter especial',
  [tokens.helper.minUpper]: '{{ field }} precisa ter no mínimo {{ count }} letra maiúscula',
  [tokens.helper.noMatch]: `não são iguais`,
  [tokens.helper.noName]: '{{ field }} não pode conter {{ notAllowed }}',
  [tokens.helper.noSeqNumber]: '{{ field }} não pode conter números sequenciais',
  [tokens.helper.noSpace]: '{{ field }} não pode conter espaço',
  [tokens.helper.notNegative]: '{{ field }} não pode ser negativo',
  [tokens.helper.underage]: 'Precisa ser maior de 18 anos',
  [tokens.joyride.tour]: 'Reiniciar Tour',
  [tokens.joyride.dashboard.welcome.title]: 'Bem-vindo ao painel',
  [tokens.joyride.dashboard.welcome.content]:
    'Este é o resumo operacional da sua rede. Use o menu à esquerda para navegar — só aparecem os módulos liberados no seu perfil.',
  [tokens.joyride.dashboard.openVenuesCard.title]: 'Estabelecimentos abertos',
  [tokens.joyride.dashboard.openVenuesCard.content]:
    'Veja quais unidades estão abertas agora e entre rapidamente em cada uma.',
  [tokens.joyride.dashboard.sessionKpis.title]: 'Operação da sessão',
  [tokens.joyride.dashboard.sessionKpis.content]:
    'Acompanhe receita, pedidos ativos, comandas abertas e alertas de estoque da sessão atual.',
  [tokens.joyride.dashboard.salesOverviewCard.title]: 'Resumo Geral de Vendas',
  [tokens.joyride.dashboard.salesOverviewCard.content]:
    'Veja como estão as suas vendas consolidadas de todos os seus estabelecimentos.',
  [tokens.joyride.appPage.title]: 'Painel operacional',
  [tokens.joyride.appPage.content]: 'Atalho para o dashboard com KPIs da sessão e visão geral da operação.',
  [tokens.joyride.analyticsPage.title]: 'Analytics',
  [tokens.joyride.analyticsPage.content]:
    'Relatórios e indicadores estratégicos de vendas (disponível conforme o plano).',
  [tokens.joyride.tabsPage.title]: 'Comandas',
  [tokens.joyride.tabsPage.content]:
    'Abra, acompanhe e feche comandas pós-pago. Ideal para pista e atendimento em mesa.',
  [tokens.joyride.inventoryPage.title]: 'Gestão de Estoque',
  [tokens.joyride.inventoryPage.content]:
    'Controle entradas, saldos e extrato de estoque dos estabelecimentos.',
  [tokens.joyride.invoicesPage.title]: 'Gestão de Faturas',
  [tokens.joyride.invoicesPage.content]: 'Acesso centralizado às faturas dos estabelecimentos.',
  [tokens.joyride.menuPage.title]: 'Cardápio',
  [tokens.joyride.menuPage.content]:
    'Categorias, produtos e cardápios. Quem só prepara pedidos pode consultar o cardápio aqui.',
  [tokens.joyride.ordersPage.title]: 'Pedidos',
  [tokens.joyride.ordersPage.content]:
    'Fila e kanban de pedidos. Conforme o perfil, você prepara, entrega ou só consulta.',
  [tokens.joyride.usersPage.title]: 'Usuários',
  [tokens.joyride.usersPage.content]:
    'Convide a equipe, atribua perfis de acesso e defina em quais unidades cada pessoa atua.',
  [tokens.joyride.venuesPage.title]: 'Estabelecimentos',
  [tokens.joyride.venuesPage.content]:
    'Cadastre e edite unidades: endereço, horário, mesas, cardápio e integrações de pagamento.',
  [tokens.joyride.securityPage.title]: 'Segurança e perfis',
  [tokens.joyride.securityPage.content]:
    'Veja os perfis de acesso e a matriz de permissões da organização.',
  [tokens.joyride.billingPage.title]: 'Assinatura',
  [tokens.joyride.billingPage.content]:
    'Plano Check, cobrança e portal de pagamento da organização.',
  [tokens.kpi.ranking]: 'Posição',
  [tokens.kpi.totalIncome]: 'Receita Total',
  [tokens.kpi.entranceFeeIncome]: 'Receita de Entrada',
  [tokens.nav.about]: 'Sobre nós',
  [tokens.nav.academy]: 'Academy',
  [tokens.nav.account]: 'Conta',
  [tokens.nav.activeOrders]: 'Pedidos Ativos',
  [tokens.nav.activeOrdersList]: 'Lista de Pedidos Ativos',
  [tokens.nav.app]: 'App',
  [tokens.nav.analytics]: 'Analítico',
  [tokens.nav.auth]: 'Autenticação',
  [tokens.nav.banking]: 'Bancário',
  [tokens.nav.billing]: 'Assinatura',
  [tokens.nav.blog]: 'Blog',
  [tokens.nav.booking]: 'Agendamento',
  [tokens.nav.brokers]: 'Corretores',
  [tokens.nav.browse]: 'Browse',
  [tokens.nav.calendar]: 'Calendário',
  [tokens.nav.canceledOrders]: 'Pedidos Cancelados',
  [tokens.nav.canceledOrdersList]: 'Lista de Pedidos Cancelados',
  [tokens.nav.cards]: 'Cartões',
  [tokens.nav.category]: 'Categoria',
  [tokens.nav.categories]: 'Categorias',
  [tokens.nav.categoryList]: 'Lista de Categorias',
  [tokens.nav.chat]: 'Chat',
  [tokens.nav.checkout]: 'Checkout',
  [tokens.nav.concepts]: 'Conceitos',
  [tokens.nav.contact]: 'Contato',
  [tokens.nav.course]: 'Curso',
  [tokens.nav.create]: 'Criar',
  [tokens.nav.crypto]: 'Crypto',
  [tokens.nav.customer]: 'Cliente',
  [tokens.nav.customers]: 'Clientes',
  [tokens.nav.dashboard]: 'Dashboard',
  [tokens.nav.details]: 'Detalhes',
  [tokens.nav.docs]: 'Documentação',
  [tokens.nav.ecommerce]: 'E-Commerce',
  [tokens.nav.economicGroup]: 'Grupo Econômico',
  [tokens.nav.edit]: 'Editar',
  [tokens.nav.error]: 'Erro',
  [tokens.nav.feed]: 'Feed',
  [tokens.nav.fileManager]: 'Gestor de Arquivos',
  [tokens.nav.files]: 'Arquivos',
  [tokens.nav.finance]: 'Finanças',
  [tokens.nav.fiscal]: 'Fiscal',
  [tokens.nav.payouts]: 'Recebimentos',
  [tokens.nav.fleet]: 'Frota',
  [tokens.nav.forgotPassword]: 'Esqueci minha senha',
  [tokens.nav.general]: 'Geral',
  [tokens.nav.globalMenu]: 'Cardápio Global',
  [tokens.nav.globalProduct]: 'Produto Global',
  [tokens.nav.home]: 'Início',
  [tokens.nav.inactiveOrders]: 'Pedidos Encerrados',
  [tokens.nav.inactiveOrdersList]: 'Lista de Pedidos Encerrados',
  [tokens.nav.inactiveTabs]: 'Comandas Encerradas',
  [tokens.nav.inventory]: 'Estoque',
  [tokens.nav.inventoryControl]: 'Controle de Estoque',
  [tokens.nav.inventoryStatement]: 'Extrato do Estoque',
  [tokens.nav.invoice]: 'Fatura',
  [tokens.nav.invoiceDetails]: 'Detalhes da Fatura',
  [tokens.nav.invoices]: 'Faturas',
  [tokens.nav.invoiceKanban]: 'Quadro de Faturas',
  [tokens.nav.invoiceList]: 'Lista de Faturas',
  [tokens.nav.jobList]: 'Job Listings',
  [tokens.nav.kanban]: 'Kanban',
  [tokens.nav.list]: 'Lista',
  [tokens.nav.login]: 'Entrar',
  [tokens.nav.logistics]: 'Logística',
  [tokens.nav.logout]: 'Sair',
  [tokens.nav.mail]: 'Correio',
  [tokens.nav.management]: 'Gestão',
  [tokens.nav.menu]: 'Cardápio',
  [tokens.nav.menus]: 'Cardápios',
  [tokens.nav.notifications]: `Notificações`,
  [tokens.nav.order]: 'Pedido',
  [tokens.nav.orders]: 'Pedidos',
  [tokens.nav.orderDetails]: 'Detalhes do Pedido',
  [tokens.nav.orderList]: 'Lista de Pedidos',
  [tokens.nav.ordersKanban]: 'Quadro de Pedidos',
  [tokens.nav.ordersList]: 'Lista de Pedidos',
  [tokens.nav.organization]: 'Organização',
  [tokens.nav.organizationProfile]: 'Dados da Organização',
  [tokens.nav.overview]: 'Visão Geral',
  [tokens.nav.pages]: 'Páginas',
  [tokens.nav.partners]: 'Parceiro',
  [tokens.nav.payment]: 'Pagamento',
  [tokens.nav.policies]: 'Políticas',
  [tokens.nav.postCreate]: 'Criar Post',
  [tokens.nav.postDetails]: 'Detalhes do Post',
  [tokens.nav.postList]: 'Lista de Post',
  [tokens.nav.pricing]: 'Pricing',
  [tokens.nav.product]: 'Produto',
  [tokens.nav.products]: 'Produtos',
  [tokens.nav.productList]: 'Lista de Produtos',
  [tokens.nav.profile]: 'Perfil',
  [tokens.nav.recoverPassword]: 'Recuperar senha',
  [tokens.nav.register]: 'Cadastrar',
  [tokens.nav.reports]: 'Relatórios',
  [tokens.nav.resetPassword]: 'Redefinir senha',
  [tokens.nav.role]: 'Perfil',
  [tokens.nav.roles]: 'Perfis',
  [tokens.nav.roleList]: 'Lista de Perfis',
  [tokens.nav.schedule]: 'Programação',
  [tokens.nav.timedMenus]: 'Cardápios por horário',
  [tokens.nav.security]: 'Segurança',
  [tokens.nav.settings]: `Configurações`,
  [tokens.nav.signUp]: `Inscrever`,
  [tokens.nav.socialMedia]: 'Midia Social',
  [tokens.nav.statement]: `Extrato`,
  [tokens.nav.stockEntry]: 'Entrada de estoque',
  [tokens.nav.stockLoss]: 'Perda de estoque',
  [tokens.nav.supplier]: `Fornecedor`,
  [tokens.nav.privacyPolicy]: 'Política de Privacidade',
  [tokens.nav.table]: 'Mesa',
  [tokens.nav.tables]: 'Mesas',
  [tokens.nav.tab]: 'Comanda',
  [tokens.nav.tabs]: 'Comandas',
  [tokens.nav.tabDetails]: 'Detalhes da Comanda',
  [tokens.nav.tabsKanban]: 'Quadro de Comandas',
  [tokens.nav.tabsList]: 'Lista de Comandas',
  [tokens.nav.terms]: 'Termos e Condições',
  [tokens.nav.verifyCode]: 'Verificar Código',
  [tokens.nav.verifyEmail]: 'Verificar E-mail',
  [tokens.nav.venue]: 'Estabelecimento',
  [tokens.nav.venues]: 'Estabelecimentos',
  [tokens.nav.venueList]: 'Lista de Estabelecimentos',
  [tokens.nav.venueScheduleTable]: 'Programação dos Estabelecimentos',
  [tokens.nav.user]: 'Usuário',
  [tokens.nav.users]: 'Usuários',
  [tokens.nav.userList]: 'Lista de Usuários',

  [tokens.payment.refund.button]: 'Solicitar reembolso',
  [tokens.payment.refund.confirmTitle]: 'Confirmar reembolso',
  [tokens.payment.refund.confirmMessage]: 'O valor será devolvido ao cliente via Stripe. Esta ação não pode ser desfeita.',
  [tokens.payment.refund.confirmMessagePix]: 'O valor será devolvido ao cliente via PIX. Esta ação não pode ser desfeita.',
  [tokens.payment.refund.confirmHint]: 'O valor devolvido é o cobrado do cliente no cartão (inclui taxa de processamento e tarifa Check). O status atualiza após a Stripe confirmar. Disponível por até 12 horas após o pagamento.',
  [tokens.payment.refund.confirmHintPix]: 'O status de pagamento será atualizado após a confirmação da Woovi. Disponível por até 12 horas após o pagamento.',
  [tokens.payment.refund.confirmAction]: 'Reembolsar',
  [tokens.payment.refund.windowHours]: '12 horas',
  [tokens.pages.app.bannerHeader]: 'Bem-vindo de volta',
  [tokens.pages.app.bannerSubtitle]: `As promoções ativadas no último mês impulsionaram as suas vendas! Que tal cadastrar novas promoções?`,
  [tokens.pages.app.bannerCTA]: 'Cadastrar promoções',
  [tokens.pages.app.networkBanner]:
    'Você está na visão da rede: os números somam todos os estabelecimentos. Para operar uma unidade — pedidos, estoque e configurações só dela — use Operar na lista abaixo ou o seletor do topo.',
  [tokens.pages.app.networkBannerCta]: 'Ver estabelecimentos',
  [tokens.pages.app.sessionByVenueTitle]: 'Sessão por estabelecimento',
  [tokens.pages.app.sessionByVenueSubtitle]:
    'Comparativo da sessão atual. Operar entra na unidade; a visão consolidada continua no seletor do topo.',
  [tokens.pages.app.metricRevenue]: 'receita',
  [tokens.pages.app.metricActiveOrders]: 'pedidos ativos',
  [tokens.pages.app.metricTabs]: 'comandas',
  [tokens.pages.app.metricAvgTicket]: 'ticket médio',
  [tokens.pages.fastpassCheckout.formHeader]: 'Checkout Express',
  [tokens.pages.fastpassCheckout.formFooterStart]: 'Ao continuar, confirmo ter lido e estar de acordo com os',
  [tokens.pages.fastpassCheckout.formFooterEnd]: 'do Check',
  [tokens.pages.fastpassCheckout.initialFormSubtitle]: 'Digite o seu CPF e número da comanda para realizar o pagamento.',
  [tokens.pages.fastpassCheckout.paymentCompleteHeader]: 'Obrigado pela sua preferência!',
  [tokens.pages.fastpassCheckout.paymentCompleteSubtitle]: 'Pagamento realizado com sucesso! Utilize o QR Code abaixo para saída do estabelecimento.',
  [tokens.pages.fastpassCheckout.paymentFormSubtitle]: 'Efetue o pagamento da sua comanda para gerar o QR Code de saída.',
  [tokens.pages.fastpassCheckout.choosePaymentMethod]: 'Como você prefere pagar?',
  [tokens.pages.fastpassCheckout.payWithCard]: 'Cartão de crédito',
  [tokens.pages.fastpassCheckout.payWithPix]: 'PIX',
  [tokens.pages.fastpassCheckout.pixScanHint]: 'Escaneie o QR Code com o app do seu banco',
  [tokens.pages.fastpassCheckout.pixCopyCode]: 'Copiar código PIX',
  [tokens.pages.fastpassCheckout.pixCopied]: 'Código copiado!',
  [tokens.pages.fastpassCheckout.pixAwaiting]: 'Aguardando confirmação do pagamento...',
  [tokens.pages.fastpassCheckout.pixExpiredTitle]: 'PIX expirado',
  [tokens.pages.fastpassCheckout.pixExpiredMessage]: 'O tempo para pagamento expirou. Volte e tente novamente.',
  [tokens.pages.fastpassCheckout.cardPaymentError]: 'Ocorreu um erro inesperado ao processar o pagamento.',
  [tokens.pages.fastpassCheckout.wantReceiptPrompt]: 'Quer receber o comprovante deste pagamento por e-mail?',
  [tokens.pages.fastpassCheckout.receiptEmailPlaceholder]: 'Seu e-mail',
  [tokens.pages.fastpassCheckout.sendReceipt]: 'Enviar comprovante',
  [tokens.pages.fastpassCheckout.receiptSent]: 'Comprovante enviado! Confira seu e-mail.',
  [tokens.pages.fastpassCheckout.noOrdersFound]: 'Nenhum pedido encontrado.',
  [tokens.pages.fastpassCheckout.noOrdersPlaced]: 'Nenhum pedido realizado.',
  [tokens.pages.fastpassCheckout.confirmCloseStep]: 'Confirmação',
  [tokens.pages.fastpassCheckout.confirmTabClose]: 'Confirmar fechamento',
  [tokens.pages.fastpassCheckout.zeroCloseTitle]: 'Fechar comanda sem cobrança',
  [tokens.pages.fastpassCheckout.zeroCloseMessage]: 'Não há consumo nem taxa de entrada nesta comanda. Deseja fechá-la sem pagamento?',
  [tokens.pages.fastpassCheckout.zeroCloseHint]: 'Nenhuma cobrança será realizada.',
  [tokens.pages.fastpassCheckout.zeroCloseFormSubtitle]: 'Confirme o fechamento da comanda para gerar o QR Code de saída.',
  [tokens.pages.fastpassCheckout.zeroCloseCompleteSubtitle]: 'Comanda fechada! Utilize o QR Code abaixo para saída do estabelecimento.',
  [tokens.pages.fastpassCheckout.zeroCloseConfirmationFooter]: 'Qualquer dúvida, entre em contato com o estabelecimento.',
  [tokens.pages.fastpassCheckout.zeroCloseError]: 'Não foi possível fechar a comanda. Tente novamente.',
  [tokens.pages.fastpassCheckout.rateLimitedError]: 'Muitas tentativas. Aguarde alguns minutos e tente novamente.',
  [tokens.pages.fastpassCheckout.sessionExpiredError]: 'Sua sessão expirou. Informe o CPF e o número da comanda novamente.',
  [tokens.pages.fastpassCheckout.tipLabel]: 'Gorjeta',
  [tokens.pages.fastpassCheckout.tipHint]: 'Opcional. O valor entra no total antes do pagamento.',
  [tokens.pages.fastpassCheckout.tipNone]: 'Sem gorjeta',
  [tokens.pages.fastpassCheckout.tipPercent]: '{{percent}}%',
  [tokens.pages.fastpassCheckout.tipCustom]: 'Outro',
  [tokens.pages.fastpassCheckout.tipCustomPlaceholder]: 'Valor em R$',
  [tokens.pages.fastpassCheckout.tipApply]: 'Aplicar',
  [tokens.pages.fastpassCheckout.tipError]: 'Não foi possível salvar a gorjeta. Tente novamente.',
  [tokens.pages.fastpassCheckout.handoffCodeLabel]: 'Código da sua comanda',
  [tokens.pages.fastpassCheckout.copyCode]: 'Copiar código',
  [tokens.pages.fastpassCheckout.showCodeAtCounter]: 'Mostre este código no balcão para retirar o pedido ou sair.',
  [tokens.pages.fastpassCheckout.exitCodeHint]: 'Mostre este QR Code na saída',
  [tokens.pages.fastpassCheckout.pickupCodeHint]: 'Mostre este QR Code para retirar o pedido #{{order}}',
  [tokens.pages.fastpassCheckout.confirmationFooter]: 'Enviamos um e-mail de confirmação com os detalhes do pagamento. Qualquer dúvida, entre em contato com o estabelecimento.',
  [tokens.pages.forbidden.header]: 'Acesso Proibido',
  [tokens.pages.forbidden.subtitle]: 'Você não tem permissão para acessar esta página. Por favor entre em contato com o administrador.',
  [tokens.pages.globalMenu.dialogSubtitle]: 'Selecione os produtos para adicionar ao cardápio do estabelecimento',
  [tokens.pages.invoice.codeDialogHeader]: 'Digite o código de validação de entrega',
  [tokens.pages.invoice.codeDialogText]: 'Por favor solicite ao cliente o código de validação de 4 dígitos',
  [tokens.pages.invoice.leftFootnote]: 'Este comprovante não tem validade fiscal.',
  [tokens.pages.invoice.reminderDialogAlert] : 'O cliente será notificado que o seu pedido está',
  [tokens.pages.invoice.reminderDialogHeader]: 'Lembrar Cliente',
  [tokens.pages.invoice.reminderDialogSubtitle]: 'Podemos notificar o cliente mais uma vez caso o pedido ainda não tenha sido retirado.',
  [tokens.pages.invoice.reminderDialogText]: 'Gostaria de continuar?',
  [tokens.pages.invoice.rightFootnote]: 'suporte@checktech.app',
  [tokens.pages.invoice.updateDialogAlert]: 'O cliente será notificado da',
  [tokens.pages.invoice.updateDialogAlertStrong]: 'situação atualizada do pedido',
  [tokens.pages.invoice.updateDialogHeader]: 'Atualizar a Situação do Pedido',
  [tokens.pages.invoice.updateDialogText]: 'Por favor confirme a alteração para a próxima situação',
  [tokens.pages.order.kanbanSearchPlaceholder]: 'Buscar por número ou cliente…',
  [tokens.pages.order.kanbanSearchEmpty]: 'Nenhum pedido encontrado',
  [tokens.pages.order.captureRetry]: 'Tentar capturar de novo',
  [tokens.pages.order.captureRetrySuccess]: 'Pagamento capturado. Pode entregar o pedido.',
  [tokens.pages.order.captureBlockedTitle]: 'A captura do cartão falhou. O pedido não foi marcado como entregue.',
  [tokens.pages.order.captureWaitingAuth]: 'A autorização do cliente expirou. O pedido fica bloqueado até ele autorizar de novo no app.',
  [tokens.pages.order.captureWaitingAuthCta]: 'Aguardando o cliente',
  [tokens.pages.order.captureOk]: 'Capturado',
  [tokens.pages.login.formHeader]: 'Entrar no Check',
  [tokens.pages.login.formSubtitle]: 'Entre com os seus dados',
  [tokens.pages.login.noAccountText]: 'Não possui uma conta?',
  [tokens.pages.login.sideBanner]: 'Olá, bem-vindo novamente!',
  [tokens.pages.maintenance.header]: 'Estamos em manutenção',
  [tokens.pages.maintenance.subtitle]: 'Estamos trabalhando para melhorar a sua experiência. Volte em breve!',
  [tokens.pages.notFound.header]: 'Página não encontrada',
  [tokens.pages.notFound.subtitle]: 'A página que você está procurando não existe ou foi movida. Confira o endereço e tente novamente.',
  [tokens.pages.product.details]: 'Detalhes do Produto',
  [tokens.pages.product.inventoryDescription]: 'Defina o estoque mínimo do produto, assim te avisamos quando o estoque estiver baixo',
  [tokens.pages.product.switchDescription]: 'Mantenha desativado para {{ action }} este produto sem afetar o cardápio dos estabelecimentos',
  [tokens.pages.product.pricingAndInventory]: 'Preço e estoque',
  [tokens.pages.register.formHeader]: 'Cadastrar no Check',
  [tokens.pages.register.formSubtitle]: 'Seu novo sistema cashless e cardless',
  [tokens.pages.register.formFooterStart]: 'Ao cadastrar, confirmo ter lido e estar de acordo com os',
  [tokens.pages.register.formFooterEnd]: 'do Check',
  [tokens.pages.register.existingAccountText]: 'Já possui uma conta?',
  [tokens.pages.register.sideBanner]: 'Otimize a sua operação com o Check',
  [tokens.pages.serverError.header]: 'Erro no Servidor',
  [tokens.pages.serverError.subtitle]: 'Ocorreu um erro inesperado. Por favor tente novamente mais tarde.',
  [tokens.pages.signUp.formHeader]: 'Quer ter o Check no seu Estabelecimento?',
  [tokens.pages.signUp.formSubtitle]: 'Atualmente o acesso está restrito a parceiros convidados. Se inscreva abaixo na lista de espera. Entraremos em contato quando for hora de impulsionar a sua operação!',
  [tokens.pages.signUp.formFooterStart]: 'Ao inscrever, confirmo ter lido e estar de acordo com os',
  [tokens.pages.signUp.formFooterEnd]: 'do Check',
  [tokens.pages.signUp.existingAccountText]: 'Já possui uma conta?',
  [tokens.pages.signUp.sideBanner]: 'Seja um Parceiro Check!',
  [tokens.pages.resetPwrd.formHeader]: 'Esqueceu a sua senha?',
  [tokens.pages.resetPwrd.formSubtitle]: 'Por favor digite o e-mail associado a sua conta que enviaremos um link para redefinir a sua senha.',
  [tokens.pages.schedule.formAlert]: 'O estabelecimento irá abrir e fechar automaticamente para o público de acordo com esta configuração. Você poderá alterar manualmente o funcionamento na aba',
  [tokens.pages.schedule.formHeader]: 'Detalhes da Grade Horária',
  [tokens.pages.schedule.formSubtitle]: 'Defina a programação de funcionamento e atendimento ao público.',
  [tokens.pages.schedule.closesAt]: 'Fecha às',
  [tokens.pages.schedule.openUntil]: 'Aberto até às',
  [tokens.pages.schedule.opensAt]: 'Abre às',
  [tokens.pages.timedMenus.title]: 'Cardápios por horário',
  [tokens.pages.timedMenus.subtitle]: 'Defina quais categorias aparecem no app conforme o horário de funcionamento.',
  [tokens.pages.timedMenus.menuName]: 'Nome do cardápio',
  [tokens.pages.timedMenus.menuDefault]: 'Cardápio padrão',
  [tokens.pages.timedMenus.priority]: 'Prioridade',
  [tokens.pages.timedMenus.priorityHelp]: 'Em horários sobrepostos, todos os cardápios correspondentes aparecem no app. Menor prioridade aparece primeiro.',
  [tokens.pages.timedMenus.menuSchedule]: 'Horários de ativação',
  [tokens.pages.timedMenus.menuCategories]: 'Categorias do cardápio',
  [tokens.pages.timedMenus.noMenus]: 'Nenhum cardápio por horário cadastrado.',
  [tokens.pages.timedMenus.addMenu]: 'Adicionar cardápio',
  [tokens.pages.timedMenus.editMenu]: 'Editar cardápio',
  [tokens.pages.timedMenus.nameRequired]: 'Informe o nome do cardápio.',
  [tokens.pages.timedMenus.noSchedulesHint]: 'Cadastre horários na aba Programação antes de vincular.',
  [tokens.pages.timedMenus.noCategoriesHint]: 'Cadastre categorias no Cardápio Global antes de vincular.',
  [tokens.pages.timedMenus.upgradeRequired]: 'Recurso disponível no plano Essential ou superior.',
  [tokens.pages.timedMenus.upgradeDescription]: 'Com múltiplos cardápios por horário você pode exibir categorias diferentes no app conforme o período (ex.: almoço, happy hour, jantar).',
  [tokens.pages.timedMenus.upgradeCurrentPlan]: 'Seu plano atual: {{tier}}',
  [tokens.pages.timedMenus.upgradeCta]: 'Gerenciar assinatura',

  [tokens.pages.planLock.upgradeCta]: 'Gerenciar assinatura',
  [tokens.pages.planLock.upgradeRequired]: 'Recurso disponível no plano {{tier}} ou superior.',
  [tokens.pages.planLock.upgradeCurrentPlan]: 'Seu plano atual: {{tier}}',
  [tokens.pages.planLock.postpaidLegacy]: 'Este estabelecimento ainda está em pós-pago. No plano atual não é possível criar novas comandas; altere para pré-pago ou faça upgrade para Pro.',
  [tokens.pages.planLock.title.timedMenus]: 'Cardápios por horário',
  [tokens.pages.planLock.title.tableQr]: 'Mesas e QR por mesa',
  [tokens.pages.planLock.title.analytics]: 'Relatórios',
  [tokens.pages.planLock.title.postpaid]: 'Pós-pago / comanda',
  [tokens.pages.planLock.title.tabs]: 'Comandas',
  [tokens.pages.planLock.title.inventory]: 'Estoque',
  [tokens.pages.planLock.description.timedMenus]: 'Com múltiplos cardápios por horário você exibe categorias diferentes no app conforme o período.',
  [tokens.pages.planLock.description.tableQr]: 'Monte o layout de mesas e gere QR codes individuais para cada mesa (Essential ou superior).',
  [tokens.pages.planLock.description.analytics]: 'Acompanhe desempenho e relatórios do estabelecimento (Essential ou superior).',
  [tokens.pages.planLock.description.postpaid]: 'O modo pós-pago (comanda) está disponível no plano Pro ou superior.',
  [tokens.pages.planLock.description.tabs]: 'Gerencie comandas abertas no estabelecimento (Pro ou superior).',
  [tokens.pages.planLock.description.inventory]: 'Controle de estoque e lançamentos estão disponíveis no plano Pro ou superior.',
  [tokens.pages.planLock.featureLost.timedMenus]: 'Cardápios por horário',
  [tokens.pages.planLock.featureLost.tableQr]: 'QR Code por mesa / edição de layout',
  [tokens.pages.planLock.featureLost.analytics]: 'Relatórios (Analytics)',
  [tokens.pages.planLock.featureLost.postpaid]: 'Modo pós-pago (comanda)',
  [tokens.pages.planLock.featureLost.tabs]: 'Comandas no painel',
  [tokens.pages.planLock.featureLost.inventory]: 'Estoque',
  [tokens.pages.tab.clientFormHeader]: 'Dados do Cliente',
  [tokens.pages.tab.clientFormSubtitle]: 'Preencha os dados do cliente para iniciar a comanda',
  [tokens.pages.tab.tableFormBypassButton]: 'Continuar sem atriubuir mesa',
  [tokens.pages.tab.tableFormSubtitle]: 'Onde entregar pedidos desta comanda no salão? (não altera divisão de pagamento)',
  [tokens.pages.tab.tableNotAssigned]: 'Nenhuma mesa atribuída',
  [tokens.pages.tab.codeDialogHeader]: 'Digite o código de validação de encerramento da comanda',
  [tokens.pages.tab.codeDialogText]: 'Por favor solicite ao cliente o código de validação de 4 dígitos',
  [tokens.pages.tab.exitCodeDialogText]: 'Informe o número da comanda e o código de validação de 4 dígitos do cliente',
  [tokens.pages.tab.entryQrDialogHeader]: 'Validar Entrada',
  [tokens.pages.tab.entryQrDialogText]: 'Escaneie o QR Code para validar a entrada.',
  [tokens.pages.tab.exitQrDialogHeader]: 'Validar Saída',
  [tokens.pages.tab.exitQrDialogText]: 'Escaneie o QR Code de saída da comanda paga.',
  [tokens.pages.tab.exitQrIsEntryError]: 'Este QR Code é de entrada. Use Validar Entrada.',
  [tokens.pages.tab.entryQrIsExitError]: 'Este QR Code é de saída. Use Validar Saída.',
  [tokens.pages.tab.exitQrIsOrderError]: 'Este QR Code é de entrega do pedido. Use a validação do pedido no drawer.',
  [tokens.pages.tab.exitQrTabMismatch]: 'O QR Code não corresponde a esta comanda.',
  [tokens.pages.tab.tabIdDigitsOnly]: 'Informe apenas os números da comanda',
  [tokens.pages.tab.leftFootnote]: 'Este comprovante não tem validade fiscal.',
  [tokens.pages.tab.noOrders]: 'Nenhum pedido realizado ainda',
  [tokens.pages.tab.kanbanSearchPlaceholder]: 'Buscar por número ou cliente…',
  [tokens.pages.tab.kanbanSearchEmpty]: 'Nenhuma comanda encontrada',
  [tokens.pages.tab.orderSearchPlaceholder]: 'Buscar no cardápio…',
  [tokens.pages.tab.orderEmptyMenu]: 'Nenhum produto disponível no cardápio ativo',
  [tokens.pages.tab.orderReviewCta]: 'Revisar',
  [tokens.pages.tab.orderCommentTitle]: 'Observação do item',
  [tokens.pages.tab.orderCommentPlaceholder]: 'Observação opcional para a cozinha',
  [tokens.pages.tab.orderReviewTitle]: 'Revisar pedido',
  [tokens.pages.tab.orderConfirmCta]: 'Confirmar pedido',
  [tokens.pages.tab.orderSuccessTitle]: 'Pedido criado',
  [tokens.pages.tab.orderSuccessCode]: 'Código da cozinha',
  [tokens.pages.tab.orderBackToTab]: 'Voltar à comanda',
  [tokens.pages.tab.orderAnother]: 'Novo pedido nesta comanda',
  [tokens.pages.tab.orderViewDetails]: 'Ver pedido',
  [tokens.pages.tab.orderStepMenu]: 'Cardápio',
  [tokens.pages.tab.orderStepReview]: 'Revisão',
  [tokens.pages.tab.orderStepDone]: 'Concluído',
  [tokens.pages.tab.orderNeedsTable]: 'Atribua uma mesa a esta comanda antes de fazer o pedido.',
  [tokens.pages.tab.orderTabNotOpen]: 'Pedidos só podem ser feitos em comanda aberta.',
  [tokens.pages.tab.entranceFee.splitsHeader]: 'Participantes',
  [tokens.pages.tab.entranceFee.chargedAtClose]: 'O valor de entrada é definido quando cada participante entra e cobrado no fechamento da comanda.',
  [tokens.pages.tab.entranceFee.closeTotal]: 'Total no fechamento',
  [tokens.pages.tab.entranceFee.entryTotal]: 'Entradas',
  [tokens.pages.tab.entranceFee.splitAccepted]: 'Aceito',
  [tokens.pages.tab.entranceFee.splitPending]: 'Pendente',
  [tokens.pages.tab.entranceFee.splitAwaitingEntry]: 'Aguardando entrada',
  [tokens.pages.tab.entranceFee.splitPresent]: 'Presente',
  [tokens.pages.tab.entranceFee.splitPaid]: 'Pago',
  [tokens.pages.tab.entranceFee.splitOther]: 'Outro',
  [tokens.pages.tab.entranceFee.newTabLabel]: 'Entrada · {{ value }}',
  [tokens.pages.tab.entranceFee.newTabHint]: 'Por participante · taxa vigente agora · cobrada no fechamento',
  [tokens.pages.tab.entranceFee.processingFee]: 'Taxa de processamento',
  [tokens.pages.tab.paymentProgress.header]: 'Progresso do pagamento dividido',
  [tokens.pages.tab.paymentProgress.paid]: 'Pago até agora',
  [tokens.pages.tab.paymentProgress.remaining]: 'Restante',
  [tokens.pages.tab.paymentProgress.whoPaid]: 'Participantes',
  [tokens.pages.tab.paymentProgress.owes]: 'Deve {{amount}}',
  [tokens.pages.tab.minimumTopUp.label]: 'Complemento mínimo',
  [tokens.pages.tab.minimumTopUp.hint]: 'O total ({{ current }}) está abaixo do mínimo de {{ minimum }}. Este complemento de {{ topUp }} completa a diferença.',
  [tokens.pages.tab.minimumTopUp.closeAlertTitle]: 'Comanda abaixo do mínimo',
  [tokens.pages.tab.minimumTopUp.closeAlertMessage]: 'O total ({{ current }}) está abaixo do mínimo de {{ minimum }}. Será cobrado um complemento de {{ topUp }}. Total a pagar: {{ payable }}.',
  [tokens.pages.tab.reminderDialogAlert] : 'O cliente será notificado que sua comanda está',
  [tokens.pages.tab.reminderDialogHeader]: 'Lembrar Cliente',
  [tokens.pages.tab.reminderDialogSubtitle]: 'Podemos notificar o cliente mais uma vez caso a comannda ainda não tenha sido encerrada.',
  [tokens.pages.tab.reminderDialogText]: 'Gostaria de continuar?',
  [tokens.pages.tab.rightFootnote]: 'suporte@checktech.app',
  [tokens.pages.tab.updateDialogAlert]: 'O cliente será notificado da',
  [tokens.pages.tab.updateDialogAlertStrong]: 'situação atualizada da comanda',
  [tokens.pages.tab.updateDialogHeader]: 'Atualizar a Situação da Comanda',
  [tokens.pages.tab.updateDialogText]: 'Por favor confirme a alteração para a próxima situação',
  [tokens.pages.tab.venueStepHelper]: `Somente Estabelecimentos com modo de pagamento Pós-pago (Comanda) são exibidos.`,
  [tokens.pages.userProfile.general.scheduleSwitch]: 'Sincronizar com a programação de funcionamento do estabelecimento',
  [tokens.pages.userProfile.general.scheduleSwitchTooltip]: 'O acesso do usuário ficará desabilitado fora do horário de funcionamento',
  [tokens.pages.userProfile.general.scheduleSwitchDisabledTooltip]: 'Não é possível sincronizar este perfil de usuário',
  [tokens.pages.userProfile.general.statusSwitch]: 'Inativar o acesso do usuário à plataforma',
  [tokens.pages.userProfile.general.statusSwitchDisabledTooltip]: 'Não é possível inativar o seu próprio acesso',
  [tokens.pages.userProfile.general.roleDialogHeader]: 'Permissões do Perfil {{ role }}',
  [tokens.pages.userProfile.general.roleDialogSubtitle]: '',
  [tokens.pages.userProfile.security.altHeader]: 'Não é possível alterar o seu próprio acesso aos estabelecimentos',
  [tokens.pages.userProfile.security.header]: 'Configure quais estabelecimentos o {{name}} pode acessar',
  [tokens.pages.userProfile.security.helper]:
    'Quem está à direita vê e opera a unidade no seletor do topo. A organização é a mesma; o acesso é por estabelecimento.',
  [tokens.pages.userProfile.security.listAltHeader]: 'Estabelecimentos Autorizados',
  [tokens.pages.userProfile.security.listHeader]: 'Estabelecimentos Não Autorizados',
  [tokens.pages.userProfile.invite.venuesHeader]: 'Estabelecimentos',
  [tokens.pages.userProfile.invite.venuesHelper]:
    'O convite já inclui acesso a estes estabelecimentos. A pessoa só entra depois de definir a senha e, no painel, só vê as unidades atribuídas (seletor do topo e operação). Depois dá para mudar na aba Segurança.',
  [tokens.pages.userProfile.invite.venuesRequired]: 'Selecione pelo menos um estabelecimento',
  [tokens.pages.userProfile.invite.pending]: 'Convite pendente',
  [tokens.pages.userProfile.invite.accepted]: 'Convite aceito',
  [tokens.pages.organizationProfile.helper]:
    'Nome e descrição da conta da rede. Não troca de organização — só edita os dados desta.',
  [tokens.pages.organizationProfile.missingOrg]: 'Não encontramos a organização desta conta.',
  [tokens.pages.userList.removeDialogHeader]: 'Remover da equipe?',
  [tokens.pages.userList.removeDialogBody]: '{{name}} deixará de ter acesso a esta organização e aos estabelecimentos.',
  [tokens.pages.userList.removeDialogBodyMany]: 'Os usuários selecionados deixarão de ter acesso a esta organização e aos estabelecimentos.',
  [tokens.pages.userList.removeDialogNote]: 'A exclusão total da conta Check precisa ser solicitada pelo próprio usuário.',
  [tokens.pages.venues.noData]: `Nenhum estabelecimento encontrado`,
  [tokens.pages.venues.noDataTitle]: `Comece cadastrando o seu primeiro!`,
  [tokens.pages.venues.overLimitBanner]: 'Você tem {{count}} estabelecimentos ativos, mas o plano {{tier}} permite até {{limit}}. Faça upgrade do plano ou desative algum estabelecimento nas configurações.',
  [tokens.pages.venues.overLimitShort]: 'Limite de estabelecimentos excedido',
  [tokens.pages.venues.overLimitTooltip]: 'Limite de estabelecimentos excedido. Faça upgrade do plano ou desative algum estabelecimento para regularizar.',
  [tokens.pages.venues.overLimitCta]: 'Gerenciar assinatura',
  [tokens.pages.venues.overLimitViewCta]: 'Ver estabelecimentos',
  [tokens.pages.venues.networkHelpTitle]: 'Organização e estabelecimento',
  [tokens.pages.venues.networkHelp]:
    'A organização é a conta da rede. Cada estabelecimento tem operação própria. Esta lista cadastra e configura unidades. Para operar uma delas (pedidos, estoque, configurações só dela), use o seletor do topo.',
  [tokens.pages.venues.bulkEditDialogHeader]: 'Alterar Estabelecimentos Selecionados',
  [tokens.pages.venues.bulkEditDialogSubtitle]: 'Defina quais campos você quer editar para todas os estabelecimentos selecionados e defina o valor desejado.',
  [tokens.pages.venueProfile.readOnlyBanner]:
    'Você pode visualizar este estabelecimento, mas não tem permissão para editar.',
  [tokens.pages.venueProfile.docs.header]: 'Documentação para verificação',
  [tokens.pages.venueProfile.docs.subtitle]: 'Envie a documentação necessária para verificação do estabelecimento',
  [tokens.pages.venueProfile.fiscal.header]: 'Dados Fiscais',
  [tokens.pages.venueProfile.fiscal.addressCheck]: 'Engereço de Registro',
  [tokens.pages.venueProfile.fiscal.addressCheckSub]: 'Utilizar o mesmo que o endereço de funcionamento',
  [tokens.pages.venueProfile.payouts.header]: 'Recebimentos',
  [tokens.pages.venueProfile.payouts.subtitle]: 'Ative os recebimentos para receber os pagamentos processados pelo Check diretamente na sua conta bancária',
  [tokens.pages.venueProfile.payouts.statusNotConnected]: 'Não ativado',
  [tokens.pages.venueProfile.payouts.statusOnboarding]: 'Em andamento',
  [tokens.pages.venueProfile.payouts.statusActive]: 'Ativo',
  [tokens.pages.venueProfile.payouts.statusReady]: 'Pronto',
  [tokens.pages.venueProfile.payouts.statusRestricted]: 'Restrito',
  [tokens.pages.venueProfile.payouts.notConnectedBody]: 'Complete o cadastro para começar a receber os pagamentos dos seus pedidos e comandas diretamente na sua conta.',
  [tokens.pages.venueProfile.payouts.onboardingBody]: 'Finalize o cadastro na Stripe para ativar os recebimentos deste estabelecimento.',
  [tokens.pages.venueProfile.payouts.activeBody]: 'Os pagamentos do Check estão sendo liquidados na sua conta Connect. Acesse o painel Stripe para saldo, repasses e dados bancários.',
  [tokens.pages.venueProfile.payouts.readyBody]:
    'O cadastro Stripe está completo. Ative o interruptor abaixo para passar a receber os pagamentos do Check na conta Connect deste estabelecimento.',
  [tokens.pages.venueProfile.payouts.restrictedBody]: 'Há pendências que precisam ser resolvidas para manter os recebimentos ativos. Continue o cadastro para completar as informações.',
  [tokens.pages.venueProfile.payouts.cta]: 'Ativar recebimentos',
  [tokens.pages.venueProfile.payouts.continueCta]: 'Continuar cadastro',
  [tokens.pages.venueProfile.payouts.manageCta]: 'Gerenciar cadastro',
  [tokens.pages.venueProfile.payouts.setupTitle]: 'Ativar recebimentos',
  [tokens.pages.venueProfile.payouts.openDashboard]: 'Abrir painel Stripe',
  [tokens.pages.venueProfile.payouts.fiscalRequired]: 'Complete os dados fiscais (razão social e CNPJ) na aba Fiscal antes de ativar os recebimentos.',
  [tokens.pages.venueProfile.payouts.invalidCnpj]: 'CNPJ inválido: precisa ter exatamente 14 dígitos. Abra a aba Fiscal, corrija o CNPJ e salve antes de ativar.',
  [tokens.pages.venueProfile.payouts.sideHeader]: 'Detalhes da conta',
  [tokens.pages.venueProfile.payouts.accountId]: 'ID da conta',
  [tokens.pages.venueProfile.payouts.feeLabel]: 'Taxa de intermediação',
  [tokens.pages.venueProfile.payouts.requirementsLabel]: 'Pendências',
  [tokens.pages.venueProfile.payouts.noRequirements]: 'Nenhuma pendência',
  [tokens.pages.venueProfile.payouts.footer]: 'Os recebimentos são processados pela Stripe.',
  [tokens.pages.venueProfile.payouts.genericError]: 'Não foi possível carregar os dados de recebimentos. Tente novamente.',
  [tokens.pages.venueProfile.payouts.confirmTitle]: 'Confirmar ativação de recebimentos',
  [tokens.pages.venueProfile.payouts.confirmIntro]:
    'Ao confirmar, enviaremos os dados abaixo à Stripe para criar a conta de recebimentos deste estabelecimento. Confira se estão corretos antes de continuar.',
  [tokens.pages.venueProfile.payouts.confirmDataHeader]: 'Dados que serão enviados',
  [tokens.pages.venueProfile.payouts.confirmNextStep]:
    'Em seguida, você concluirá o cadastro na Stripe (dados bancários e verificação). Os pagamentos do Check serão repassados para a conta bancária informada.',
  [tokens.pages.venueProfile.payouts.confirmContactEmailNote]:
    'O e-mail da sua conta no Check será usado como contato junto à Stripe.',
  [tokens.pages.venueProfile.payouts.confirmAddressFromVenue]: 'Endereço de funcionamento',
  [tokens.pages.venueProfile.payouts.confirmAddressFromFiscal]: 'Endereço fiscal',
  [tokens.pages.venueProfile.payouts.confirmMissingValue]: 'Não informado',
  [tokens.pages.venueProfile.payouts.settlementToggle]: 'Receber na conta Connect',
  [tokens.pages.venueProfile.payouts.settlementToggleHelp]:
    'Quando ativo, os pagamentos do Check são liquidados na conta Stripe deste estabelecimento. Quando desativo, o fluxo permanece no modo legado da plataforma.',
  [tokens.pages.venueProfile.payouts.settlementToggleBlocked]:
    'Conclua o cadastro Stripe (cobranças habilitadas) antes de ativar.',
  [tokens.pages.venueProfile.payouts.settlementOn]: 'Recebimentos na conta Connect ativos',
  [tokens.pages.venueProfile.payouts.settlementOff]: 'Recebimentos na conta Connect desativados',
  [tokens.pages.venueProfile.payouts.reqGroup.business]: 'Perfil do negócio',
  [tokens.pages.venueProfile.payouts.reqGroup.company]: 'Dados da empresa',
  [tokens.pages.venueProfile.payouts.reqGroup.directors]: 'Diretores',
  [tokens.pages.venueProfile.payouts.reqGroup.executives]: 'Executivos',
  [tokens.pages.venueProfile.payouts.reqGroup.owners]: 'Sócios / proprietários',
  [tokens.pages.venueProfile.payouts.reqGroup.representative]: 'Representante legal',
  [tokens.pages.venueProfile.payouts.reqGroup.individual]: 'Pessoa física',
  [tokens.pages.venueProfile.payouts.reqGroup.bank]: 'Conta bancária e termos',
  [tokens.pages.venueProfile.payouts.reqGroup.other]: 'Outras informações',
  [tokens.pages.venueProfile.payouts.reqField.productDescription]: 'Descrição dos produtos/serviços',
  [tokens.pages.venueProfile.payouts.reqField.businessName]: 'Nome do negócio',
  [tokens.pages.venueProfile.payouts.reqField.mcc]: 'Categoria do negócio',
  [tokens.pages.venueProfile.payouts.reqField.url]: 'Site ou redes sociais',
  [tokens.pages.venueProfile.payouts.reqField.supportPhone]: 'Telefone de suporte',
  [tokens.pages.venueProfile.payouts.reqField.supportEmail]: 'E-mail de suporte',
  [tokens.pages.venueProfile.payouts.reqField.directorsProvided]: 'Cadastro de diretores',
  [tokens.pages.venueProfile.payouts.reqField.executivesProvided]: 'Cadastro de executivos',
  [tokens.pages.venueProfile.payouts.reqField.ownersProvided]: 'Cadastro de sócios',
  [tokens.pages.venueProfile.payouts.reqField.taxId]: 'CNPJ',
  [tokens.pages.venueProfile.payouts.reqField.phone]: 'Telefone',
  [tokens.pages.venueProfile.payouts.reqField.email]: 'E-mail',
  [tokens.pages.venueProfile.payouts.reqField.fullName]: 'Nome completo',
  [tokens.pages.venueProfile.payouts.reqField.idNumber]: 'CPF',
  [tokens.pages.venueProfile.payouts.reqField.politicalExposure]: 'Exposição política',
  [tokens.pages.venueProfile.payouts.reqField.jobTitle]: 'Cargo',
  [tokens.pages.venueProfile.payouts.reqField.idDocument]: 'Documento de identidade',
  [tokens.pages.venueProfile.payouts.reqField.additionalDocument]: 'Documento adicional',
  [tokens.pages.venueProfile.payouts.reqField.address]: 'Endereço',
  [tokens.pages.venueProfile.payouts.reqField.dob]: 'Data de nascimento',
  [tokens.pages.venueProfile.payouts.reqField.relationship]: 'Vínculo com a empresa',
  [tokens.pages.venueProfile.payouts.reqField.verification]: 'Verificação de identidade',
  [tokens.pages.venueProfile.payouts.reqField.bankAccount]: 'Conta bancária',
  [tokens.pages.venueProfile.payouts.reqField.percentOwnership]: 'Percentual de participação',
  [tokens.pages.venueProfile.payouts.reqField.relationshipExecutive]: 'Confirmado como executivo',
  [tokens.pages.venueProfile.payouts.reqField.relationshipOwner]: 'Confirmado como sócio',
  [tokens.pages.venueProfile.payouts.reqField.relationshipDirector]: 'Confirmado como diretor',
  [tokens.pages.venueProfile.payouts.reqField.tosAcceptance]: 'Aceite dos termos',
  [tokens.pages.venueProfile.payouts.reqField.tosDate]: 'Data de aceite dos termos',
  [tokens.pages.venueProfile.payouts.reqField.tosIp]: 'IP do aceite dos termos',
  [tokens.pages.venueProfile.general.header]: 'Dados Básicos',
  [tokens.pages.venueProfile.general.entrance_feeSub]: 'Entrada padrão por participante em comandas postpaid (fallback quando o dia não tem override). Padrão atual: R$ {{ value }}',
  [tokens.pages.venueProfile.general.entrance_feeWeekdayHeader]: 'Entrada por dia da semana',
  [tokens.pages.venueProfile.general.entrance_feeWeekdaySub]: 'Override opcional por dia. Deixe em branco para usar o padrão (R$ {{ value }}).',
  [tokens.pages.venueProfile.general.entrance_feeWeekdayPlaceholder]: 'Padrão',
  [tokens.pages.venueProfile.general.entrance_feeWeekdayAfterCreate]: 'Salve o estabelecimento primeiro para configurar overrides por dia.',
  [tokens.pages.venueProfile.general.entrance_feePrepaidDisabled]: 'Entrada aplica-se apenas a estabelecimentos postpaid (comanda).',
  [tokens.pages.venueProfile.general.entrance_feeCurrent]: 'Taxa vigente se alguém entrasse agora: {{ value }}',
  [tokens.pages.venueProfile.general.openstatusSwitch]: 'Abrir manualmente o estabelecimento para o público',
  [tokens.pages.venueProfile.general.openstatusSwitchTooltip]: 'Quando aberto, o público pode fazer check-in e enviar pedidos',
  [tokens.pages.venueProfile.general.openstatusSwitchStatusTooltip]: 'Ative o Status do estabelecimento antes de abrir para o público',
  [tokens.pages.venueProfile.general.openstatusSwitchReceivingTooltip]: 'Configure e ative o recebimento (Connect) em Repasses antes de abrir',
  [tokens.pages.venueProfile.general.payment_modeSub]: 'Modo de pagamento do estabelecimento',
  [tokens.pages.venueProfile.general.service_modeSub]:
    'Mesa = destino de entrega no salão. Comandas e divisões continuam individuais no app — não há “conta da mesa”.',
  [tokens.pages.venueProfile.general.statusSwitch]: 'Aplique para deixar este estabelecimento visível ao público',
  [tokens.pages.venueProfile.general.statusSwitchTooltip]: 'Quando ativo, o estabelecimento fica visível ao público',
  [tokens.pages.venueProfile.general.statusSwitchAltTooltip]: 'Apenas estabelecimentos verificados podem ser visíveis ao público',
  [tokens.pages.venueProfile.general.statusSwitchLimitTooltip]: 'Seu plano permite até {{limit}} estabelecimentos ativos ao mesmo tempo — faça upgrade ou desative outro para ativar este',
  [tokens.pages.venueProfile.general.statusSwitchLimitCaption]: 'Limite de {{limit}} estabelecimentos ativos do plano {{tier}} atingido. Faça upgrade ou desative outro estabelecimento.',
  [tokens.pages.venueProfile.general.settingsHeader]: 'Configurações Básicas',
  [tokens.pages.venueProfile.general.min_amountSub]: 'Valor mínimo do pedido (padrão R$ {{ value }})',
  [tokens.pages.venueProfile.menu.productDialog.subtitle]: 'Defina um preço normal, preço promocional e quantidade em estoque específicos para este estabelecimento',
  [tokens.pages.venueProfile.layout.header]: 'Mapa de Mesas',
  [tokens.pages.venueProfile.layout.sub]:
    'Lista ou mapa: QR, status e cadastro. Editar layout para posição e inclusão/remoção no floor plan. Não agrupa comandas.',
  [tokens.pages.venueProfile.inventory.entryDialog.subtitle]: 'Registro de entrada de produto em estoque',
  [tokens.pages.venueProfile.inventory.historyDialog.subtitle]: 'Histórico de entrada e saída de estoque por',
  [tokens.pages.venueProfile.security.altHeader]: 'Não é possível alterar o seu próprio acesso aos estabelecimentos',
  [tokens.pages.venueProfile.security.header]: 'Configure o acesso de usuários a este estabelecimento',
  [tokens.pages.venueProfile.security.helper]:
    'Só quem está à direita opera esta unidade. Staff sem acesso não vê o estabelecimento no seletor do topo. No perfil da pessoa, a aba Segurança faz o mesmo recorte.',
  [tokens.pages.venueProfile.security.listAltHeader]: 'Usuários Autorizados',
  [tokens.pages.venueProfile.security.listHeader]: 'Usuários Não Autorizados',
  [tokens.pages.verifyCode.formHeader]: 'Código enviado com sucesso!',
  [tokens.pages.verifyCode.formSubtitleStart]: 'Enviamos um código de 6 dígitos para o seu e-mail.',
  [tokens.pages.verifyCode.formSubtitleEnd]: 'Digite o código no campo abaixo para redefinir sua senha.',
  [tokens.pages.verifyCode.formFooter]: 'Não recebeu o código?',
  [tokens.pages.verifiedEmail.header]: 'E-mail verificado com sucesso!',
  [tokens.payment_modes.postpaid]: 'Pós-pago (Comanda)',
  [tokens.payment_modes.prepaid]: 'Pré-pago (Pedido)',
  [tokens.popover.tenant.header]: 'Gestão Focada',
  [tokens.popover.tenant.subtitle]: 'Selecione um estabelecimento para ver o seu ambiente',
  [tokens.popover.tenant.generalTitle]: 'Gestão Global',
  [tokens.popover.tenant.viewOrganization]: 'Ver organização inteira',
  [tokens.tenantContext.showingVenue]: 'Mostrando: {{name}}',
  [tokens.tenantContext.showingOrganization]: 'Mostrando: {{count}} estabelecimentos',
  [tokens.tenantContext.onboardingMessage]: 'Você gerencia {{count}} estabelecimentos. Use este seletor para trocar entre a visão consolidada da organização e a de um estabelecimento por vez.',
  [tokens.tenantContext.onboardingCta]: 'Entendi',
  [tokens.tenantContext.searchPlaceholder]: 'Buscar estabelecimento…',
  [tokens.tenantContext.recent]: 'Recentes',
  [tokens.tenantContext.openOrdersCount]: '{{count}} pedidos abertos',
  [tokens.tenantContext.closed]: 'Fechado',
  [tokens.tenantContext.noResults]: 'Nenhum estabelecimento encontrado',
  [tokens.tenantContext.currentPlan]: 'Plano atual',
  [tokens.tenantContext.venueLimitUsage]: '{{count}} de {{limit}} estabelecimentos',
  [tokens.tenantContext.venueLimitUsageUnlimited]: '{{count}} estabelecimentos · sem limite',
  [tokens.security.viewAllProfiles]: 'Ver tudo',
  [tokens.security.userCount_one]: '{{count}} usuário',
  [tokens.security.userCount_other]: '{{count}} usuários',
  [tokens.security.noUsersOnProfile]: 'Nenhum usuário com este perfil',
  [tokens.roles.admin]: 'Administrador',
  [tokens.roles.bar]: 'Bar',
  [tokens.roles.bartender]: 'Bar',
  [tokens.roles.cook]: 'Cozinha',
  [tokens.roles.finance]: 'Financeiro',
  [tokens.roles.investor]: 'Investidor',
  [tokens.roles.kitchen]: 'Cozinha',
  [tokens.roles.manager]: 'Gerente',
  [tokens.roles.waiter]: 'Garçom',
  [tokens.shortpayment_modes.postpaid]: 'Pós-pago',
  [tokens.shortpayment_modes.prepaid]: 'Pré-pago',
  [tokens.shortservice_modes.counter]: 'Balcão',
  [tokens.shortservice_modes.hybrid]: 'Híbrido',
  [tokens.shortservice_modes.table]: 'Mesa',
  [tokens.service_modes.counter]: 'Serviço de Balcão',
  [tokens.service_modes.hybrid]: 'Serviço Híbrido',
  [tokens.service_modes.table]: 'Serviço de Mesa',
  [tokens.settings.themeMode]: 'Tema',
  [tokens.snackbar.codeSent.error]: 'Erro ao enviar o código',
  [tokens.snackbar.codeSent.success]: 'Código enviado com sucesso!',
  [tokens.snackbar.codeValidation.error]: 'Erro ao validar o código',
  [tokens.snackbar.codeValidation.success]: 'Código validado com sucesso!',
  [tokens.snackbar.create.error]: 'Erro ao criar',
  [tokens.snackbar.create.success]: 'Criado com sucesso!',
  [tokens.snackbar.createTab.error.existingAnotherVenue]: 'Já existe uma comanda aberta para este cliente em outro estabelecimento',
  [tokens.snackbar.createTab.error.existingSameVenue]: 'Já existe uma comanda aberta para este cliente neste estabelecimento',
  [tokens.snackbar.createTab.error.payment_modeMismatch]: 'Não é possível abrir uma comanda em estabelecimento com modo de pagamento pré-pago',
  [tokens.snackbar.createTab.error.venueClosed]: 'Não é possível abrir uma comanda em um estabelecimento fechado',
  [tokens.snackbar.createTab.error.venueInactive]: 'Não é possível abrir uma comanda em um estabelecimento inativo',
  [tokens.snackbar.createTab.error.venueDenied]: 'Você não tem permissão para abrir uma comanda neste estabelecimento',
  [tokens.snackbar.createTab.success]: 'Comanda aberta com sucesso!',
  [tokens.snackbar.delete.error]: 'Erro ao excluir',
  [tokens.snackbar.delete.success]: 'Excluído com sucesso!',
  [tokens.snackbar.entryValidation.error]: 'Erro ao validar a entrada',
  [tokens.snackbar.entryValidation.success]: 'Entrada validada com sucesso!',
  [tokens.snackbar.exitValidation.error]: 'Erro ao validar a saída',
  [tokens.snackbar.exitValidation.success]: 'Saída validada com sucesso!',
  [tokens.snackbar.fetch.error]: 'Erro ao buscar os dados',
  [tokens.snackbar.fetch.success]: 'Dados buscados com sucesso!',
  [tokens.snackbar.fileUpload.error]: 'Erro ao carregar o arquivo',
  [tokens.snackbar.fileUpload.success]: 'Arquivo carregado com sucesso!',
  [tokens.snackbar.inventoryEntry.error]: 'Erro ao registrar a entrada de estoque',
  [tokens.snackbar.inventoryEntry.success]: 'Entrada de estoque registrada com sucesso!',
  [tokens.snackbar.inventoryLoss.error]: 'Erro ao registrar a perda de estoque',
  [tokens.snackbar.inventoryLoss.success]: 'Perda de estoque registrada com sucesso!',
  [tokens.snackbar.notification.error]: 'Erro ao enviar a notificação',
  [tokens.snackbar.notification.success]: 'Notificação enviada com sucesso!',
  [tokens.snackbar.passwordChange.error]: 'Erro ao alterar a senha',
  [tokens.snackbar.passwordChange.success]: 'Senha alterada com sucesso!',
  [tokens.snackbar.resetPassword.error]: 'Erro ao recuperar a senha',
  [tokens.snackbar.resetPassword.success]: 'Senha recuperada com sucesso!',
  [tokens.snackbar.resetPasswordEmail.error]: 'Erro ao enviar e-mail de recuperação de senha',
  [tokens.snackbar.resetPasswordEmail.success]: 'Recuperação de senha enviado com sucesso para {{ email }}',
  [tokens.snackbar.resendInvite.error]: 'Erro ao reenviar o convite',
  [tokens.snackbar.resendInvite.success]: 'Convite reenviado para {{ email }}',
  [tokens.snackbar.refund.error]: 'Não foi possível processar o reembolso',
  [tokens.snackbar.refund.success]: 'Reembolso solicitado com sucesso',
  [tokens.snackbar.refund.windowExpired]: 'Prazo para reembolso expirado (12 horas após o pagamento)',
  [tokens.snackbar.signUp.error]: 'Erro ao se inscrever',
  [tokens.snackbar.signUp.success]: 'Inscrição feita com sucesso!',
  [tokens.snackbar.update.error]: 'Erro ao atualizar os dados',
  [tokens.snackbar.update.success]: 'Dados atualizados com sucesso!',
  [tokens.snackbar.update.venueActivatePlanLimit]: 'Limite de estabelecimentos ativos do plano atingido',
  [tokens.snackbar.update.venueOpenStatusRequired]: 'O estabelecimento precisa estar ativo para abrir ao público',
  [tokens.snackbar.update.venueOpenVerifiedRequired]: 'O estabelecimento precisa estar verificado para abrir ao público',
  [tokens.snackbar.update.venueOpenReceivingRequired]: 'Configure e ative o recebimento (Connect) antes de abrir',
  [tokens.snackbar.update.venueBulkAccessDenied]: 'Sem permissão para editar um ou mais estabelecimentos',
  [tokens.snackbar.verifyEmail.error]: 'Erro ao enviar verificação de e-mail',
  [tokens.snackbar.verifyEmail.success]: 'Verificação de e-mail enviada com sucesso para {{ email }}',
  [tokens.status.label.active]: 'Ativo',
  [tokens.status.label.analyzing]: 'Em análise',
  [tokens.status.label.approved]: 'Aprovado',
  [tokens.status.label.canceled]: 'Cancelado',
  [tokens.status.label.closed]: 'Fechado',
  [tokens.status.label.closing]: 'Fechando',
  [tokens.status.label.completed]: 'Finalizado',
  [tokens.status.label.connected]: 'Conectado',
  [tokens.status.label.declined]: 'Recusado',
  [tokens.status.label.disconnected]: 'Desconectado',
  [tokens.status.label.fulfilled]: 'Finalizado',
  [tokens.status.label.inactive]: 'Inativo',
  [tokens.status.label.inStock]: 'Em Estoque',
  [tokens.status.label.lowStock]: 'Estoque Baixo',
  [tokens.status.label.onSale]: 'Em promoção',
  [tokens.status.label.open]: 'Aberto',
  [tokens.status.label.opened]: 'Aberto',
  [tokens.status.label.outOfStock]: 'Fora de Estoque',
  [tokens.status.label.paid]: 'Pago',
  [tokens.status.label.paymentPending]: 'Pagamento Pendente',
  [tokens.status.label.paymentReceived]: 'Pagamento Recebido',
  [tokens.status.label.paymentRefunded]: 'Pagamento Reembolsado',
  [tokens.status.label.paymentRejected]: 'Pagamento Recusado',
  [tokens.status.label.paymentFailed]: 'Pagamento Falhou',
  [tokens.status.label.pending]: 'Pendente',
  [tokens.status.label.preparing]: 'Preparando',
  [tokens.status.label.ready]: 'Pronto para retirada',
  [tokens.status.label.readyGeneric]: 'Pronto',
  [tokens.status.label.readyTable]: 'Pronto para entregar',
  [tokens.status.label.readyTableGeneric]: 'Pronto para entregar',
  [tokens.status.label.received]: 'Recebido',
  [tokens.status.label.reconnecting]: 'Reconectando',
  [tokens.status.label.sent]: 'Enviado',
  [tokens.status.step.cancel]: 'Cancelar',
  [tokens.status.step.complete]: 'Encerrar',
  [tokens.status.step.finishPrep]: 'Finalizar preparo',
  [tokens.status.step.receive]: 'Receber',
  [tokens.status.step.startPrep]: 'Iniciar preparo',
  [tokens.status.stepAction.delivered]: 'Entregue ao cliente',
  [tokens.status.stepAction.finishedPreparation]: 'Término de preparação',
  [tokens.status.stepAction.orderCanceled]: 'Pedido cancelado',
  [tokens.status.stepAction.orderDelivered]: 'Pedido entregue',
  [tokens.status.stepAction.orderDeliveredToTable]: 'Pedido entregue ({{table}})',
  [tokens.status.stepAction.orderReceived]: 'Pedido recebido',
  [tokens.status.stepAction.orderRefunded]: 'Pedido reembolsado',
  [tokens.status.stepAction.paid]: 'Pagamento confirmado',
  [tokens.status.stepAction.paymentFailed]: 'Pagamento falhou',
  [tokens.status.stepAction.paymentRefunded]: 'Pagamento reembolsado',
  [tokens.status.stepAction.startedClosing]: 'Em fechamento',
  [tokens.status.stepAction.startedPreparation]: 'Início de preparação',
  [tokens.status.stepAction.tabCanceled]: 'Comanda cancelada',
  [tokens.status.stepAction.tabFulfilled]: 'Comanda finalizada',
  [tokens.status.stepAction.tabPaid]: 'Comanda paga',
  [tokens.status.stepAction.tabRefunded]: 'Comanda reembolsada',
  [tokens.status.stepAction.tabOpened]: 'Comanda aberta',
  [tokens.tables.openVenues]: 'Estabelecimentos Abertos',
  [tokens.tables.noOpenVenues]: 'Nenhum Estabelecimento Aberto',
  [tokens.tables.productRanking]: 'Produtos Mais Vendidos',
  [tokens.tables.emptyLayout]: 'Nenhuma mesa ainda. Adicione mesas para montar o mapa.',
  [tokens.tables.viewList]: 'Lista',
  [tokens.tables.viewMap]: 'Mapa',
  [tokens.tables.qrAfterSave]: 'O QR code fica disponível após salvar a mesa.',
  [tokens.tables.addMultiplePrompt]: 'Quantas mesas deseja adicionar?',
  [tokens.tables.invalidateQr]: 'Invalidar QR',
  [tokens.tables.invalidateQrConfirm]:
    'Invalidar este QR code? O código atual deixará de funcionar e um novo será gerado.',
  [tokens.tables.assignRequired]:
    'Este estabelecimento usa entrega em mesa. Selecione onde entregar pedidos desta comanda. (não altera divisão de pagamento)',
  [tokens.tables.assignOptional]:
    'Onde entregar pedidos desta comanda no salão? (não altera divisão de pagamento)',
  [tokens.tables.assignDialog]: 'Atribuir mesa',
  [tokens.tables.changeTable]: 'Trocar mesa',
  [tokens.tables.clearTable]: 'Remover mesa',
  [tokens.tables.deliveryHint]: 'Destino de entrega',
  [tokens.tables.openExistingTab]: 'Ver comanda #{{id}}',
  [tokens.tables.status.available]: 'Disponível',
  [tokens.tables.status.occupied]: 'Ocupada',
  [tokens.tables.status.reserved]: 'Reservada',
  [tokens.tables.status.disabled]: 'Desativada',
  [tokens.tags.containsAlcohol]: 'Contém álcool',
  [tokens.tags.nonAlcoholic]: 'Não alcoólico',
  [tokens.tags.type]: 'Tipo',
  [tokens.venueTypes.bar]: 'Bar',
  [tokens.venueTypes.events]: 'Eventos',
  [tokens.venueTypes.nightClub]: 'Balada',
  [tokens.venueTypes.restaurant]: 'Restaurante',
  [tokens.weekdays.monday]: 'Segunda-feira',
  [tokens.weekdays.tuesday]: 'Terça-feira',
  [tokens.weekdays.wednesday]: 'Quarta-feira',
  [tokens.weekdays.thursday]: 'Quinta-feira',
  [tokens.weekdays.friday]: 'Sexta-feira',
  [tokens.weekdays.saturday]: 'Sábado',
  [tokens.weekdays.sunday]: 'Domingo',

  [tokens.pages.billing.currentPlan]: 'Plano atual',
  [tokens.pages.billing.venueLimit]: 'Até {{count}} estabelecimentos',
  [tokens.pages.billing.venueLimitUnlimited]: 'Estabelecimentos ilimitados',
  [tokens.pages.billing.venueLimitOne]: 'Até 1 estabelecimento',
  [tokens.pages.billing.nextRenewal]: 'Próximo vencimento',
  [tokens.pages.billing.noRenewal]: 'Sem renovação programada',
  [tokens.pages.billing.venueUsage]: '{{active}} de {{limit}} estabelecimentos',
  [tokens.pages.billing.venueUsageUnlimited]: '{{active}} estabelecimentos (ilimitado)',
  [tokens.pages.billing.cancelAtPeriodEnd]: 'Cancelamento ao fim do período',
  [tokens.pages.billing.cancelAtPeriodEndHint]: 'Após esta data, o plano passa a {{tier}}',
  [tokens.pages.billing.managePortal]: 'Gerenciar pagamento / faturas',
  [tokens.pages.billing.refresh]: 'Atualizar',
  [tokens.pages.billing.refreshTooltip]: 'Atualizar status da assinatura',
  [tokens.pages.billing.adminsOnly]: 'Apenas administradores da organização podem gerenciar a assinatura.',
  [tokens.pages.billing.changePlan]: 'Alterar plano',
  [tokens.pages.billing.subscribePlan]: 'Assinar um plano',
  [tokens.pages.billing.monthly]: 'Mensal',
  [tokens.pages.billing.annual]: 'Anual',
  [tokens.pages.billing.perMonth]: '/mês',
  [tokens.pages.billing.perYear]: '/ano',
  [tokens.pages.billing.free]: 'Grátis',
  [tokens.pages.billing.onRequest]: 'Sob consulta',
  [tokens.pages.billing.feesLine]: '+ {{card}}% cartão · {{pix}}% PIX',
  [tokens.pages.billing.processing]: 'Processando…',
  [tokens.pages.billing.pleaseWait]: 'Aguarde…',
  [tokens.pages.billing.contactUs]: 'Entrar em contato',
  [tokens.pages.billing.policyFootnote]:
    'Upgrade e mensal→anual: cobrança da diferença agora (você confirma o valor antes). Downgrade e anual→mensal: sem estorno; muda no próximo ciclo. Voltar ao Starter: portal de cancelamento.',
  [tokens.pages.billing.pastDueAlert]:
    'Cobrança em atraso. Atualize o cartão no portal (grace de 3 dias) para manter o plano {{tier}}.',
  [tokens.pages.billing.pastDueUpdatePayment]: 'Atualizar pagamento',
  [tokens.pages.billing.incompleteAlert]:
    'A assinatura está com pagamento incompleto (cartão não confirmado ou autenticação adicional pendente). Conclua o pagamento no portal antes de trocar de plano, se o upgrade falhar.',
  [tokens.pages.billing.incompleteCompletePayment]: 'Concluir pagamento',
  [tokens.pages.billing.pendingDowngradeAlert]:
    'Downgrade agendado para {{pending}} em {{date}}. Até lá você permanece em {{current}}.',
  [tokens.pages.billing.pendingVenueExcess]:
    'Seu plano {{pending}} permite até {{limit}} estabelecimento(s) ativo(s). Você tem {{active}}. Desative pelo menos {{excess}} até {{date}}; se não desativar, desativaremos {{excess}} automaticamente (seleção aleatória).',
  [tokens.pages.billing.enforceDeactivatedAlert]:
    'Desativamos {{count}} estabelecimento(s) para caber no plano {{tier}}. Você pode reativar até o limite ou fazer upgrade.',
  [tokens.pages.billing.globalPastDueAlert]:
    'Não conseguimos processar a cobrança do plano {{tier}}. Atualize o método de pagamento em até {{days}} para não perder o plano.',
  [tokens.pages.billing.globalPastDueDays]: '{{count}} dias',
  [tokens.pages.billing.globalPastDueToday]: 'hoje',
  [tokens.pages.billing.globalPastDueOneDay]: '1 dia',
  [tokens.pages.billing.locked.title]: 'Assinatura bloqueada',
  [tokens.pages.billing.locked.subtitle]:
    'O período de tolerância da cobrança em atraso terminou. Atualize o pagamento ou assine um plano para voltar a usar o painel.',
  [tokens.pages.billing.locked.subtitleStaff]:
    'O período de tolerância da cobrança em atraso terminou. Peça ao administrador da organização para atualizar o pagamento ou assinar um plano.',
  [tokens.pages.billing.locked.manageCta]: 'Gerenciar assinatura',
  [tokens.pages.billing.locked.logoutCta]: 'Sair',
  [tokens.pages.billing.status.active]: 'Ativa',
  [tokens.pages.billing.status.trialing]: 'Trial',
  [tokens.pages.billing.status.past_due]: 'Pagamento pendente',
  [tokens.pages.billing.status.incomplete]: 'Pagamento incompleto',
  [tokens.pages.billing.status.incomplete_expired]: 'Expirada (pagamento)',
  [tokens.pages.billing.status.canceled]: 'Cancelada',
  [tokens.pages.billing.status.unpaid]: 'Não paga',
  [tokens.pages.billing.status.paused]: 'Pausada',
  [tokens.pages.billing.status.manual]: 'Manual (ops)',
  [tokens.pages.billing.status.none]: 'Sem assinatura',
  [tokens.pages.billing.cta.current]: 'Plano atual',
  [tokens.pages.billing.cta.switchToAnnual]: 'Mudar para anual',
  [tokens.pages.billing.cta.switchToMonthly]: 'Mudar para mensal',
  [tokens.pages.billing.cta.downgradeScheduled]: 'Downgrade agendado',
  [tokens.pages.billing.cta.nextCycle]: 'Próximo ciclo',
  [tokens.pages.billing.cta.talkToSales]: 'Falar com vendas',
  [tokens.pages.billing.cta.backToStarter]: 'Voltar ao Starter',
  [tokens.pages.billing.cta.downgrade]: 'Fazer downgrade',
  [tokens.pages.billing.cta.subscribe]: 'Assinar {{tier}}',
  [tokens.pages.billing.cta.upgrade]: 'Fazer upgrade',
  [tokens.pages.billing.confirm.title]: 'Confirmar alteração de plano',
  [tokens.pages.billing.confirm.calculating]: 'Calculando o valor…',
  [tokens.pages.billing.confirm.checkoutInfo]:
    'Você será redirecionado para informar o cartão e concluir a primeira assinatura.',
  [tokens.pages.billing.confirm.scheduledInfo]:
    'Nenhuma cobrança agora. A mudança vale a partir de {{date}}. Até lá você permanece no plano atual.',
  [tokens.pages.billing.confirm.immediateInfo]:
    'Ao confirmar, cobramos no cartão cadastrado o valor abaixo (pro-rata / ajuste de ciclo).',
  [tokens.pages.billing.confirm.amountDueNow]: 'A pagar agora',
  [tokens.pages.billing.confirm.nextInvoices]: 'Próximas faturas: {{amount}}/{{period}}',
  [tokens.pages.billing.confirm.goCheckout]: 'Ir para o Checkout · {{amount}}',
  [tokens.pages.billing.confirm.confirmSchedule]: 'Confirmar agendamento',
  [tokens.pages.billing.confirm.confirmCharge]: 'Confirmar e cobrar {{amount}}',
  [tokens.pages.billing.confirm.impactTitle]: 'O que muda com este downgrade',
  [tokens.pages.billing.confirm.impactKeepUntil]:
    'Até {{date}} você continua com os recursos do plano atual.',
  [tokens.pages.billing.confirm.venueExcess]:
    'O plano {{tier}} permite até {{limit}} estabelecimento(s) ativo(s). Você tem {{active}}.',
  [tokens.pages.billing.confirm.venueAutoDeactivate]:
    'Desative pelo menos {{excess}} até {{date}}. Se não desativar, na virada desativaremos automaticamente {{excess}} estabelecimento(s) (seleção aleatória entre os ativos).',
  [tokens.pages.billing.confirm.venueManageLink]: 'Gerenciar estabelecimentos',
  [tokens.pages.billing.confirm.acknowledge]:
    'Entendi o impacto e quero agendar o downgrade',
  [tokens.pages.billing.starterCancel.title]: 'Voltar ao Starter',
  [tokens.pages.billing.starterCancel.body]:
    'Você será levado ao portal para cancelar a assinatura ao fim do período atual. Até lá o plano pago continua ativo. Não há estorno do período já pago.',
  [tokens.pages.billing.starterCancel.impactTitle]: 'O que acontece ao voltar ao Starter',
  [tokens.pages.billing.starterCancel.venueExcess]:
    'O Starter permite até {{limit}} estabelecimento(s) ativo(s). Você tem {{active}}.',
  [tokens.pages.billing.starterCancel.venueAutoDeactivate]:
    'Desative pelo menos {{excess}} até o fim do período. Se não desativar, desativaremos {{excess}} automaticamente (seleção aleatória).',
  [tokens.pages.billing.starterCancel.acknowledge]:
    'Entendi e quero continuar para o portal',
  [tokens.pages.billing.starterCancel.openPortal]: 'Abrir portal',
  [tokens.pages.billing.snackbar.loadError]: 'Não foi possível carregar a assinatura',
  [tokens.pages.billing.snackbar.portalError]: 'Falha ao abrir portal',
  [tokens.pages.billing.snackbar.alreadyOnPlan]: 'Você já está neste plano e ciclo.',
  [tokens.pages.billing.snackbar.previewError]: 'Não foi possível calcular o valor',
  [tokens.pages.billing.snackbar.downgradeScheduled]:
    'Downgrade agendado para {{date}}. Você permanece no plano atual até lá.',
  [tokens.pages.billing.snackbar.cycleToMonthlyScheduled]:
    'Ciclo mensal agendado para {{date}}. Você permanece no anual até lá.',
  [tokens.pages.billing.snackbar.cycleToAnnual]: 'Ciclo alterado para anual. Diferença cobrada agora.',
  [tokens.pages.billing.snackbar.upgrade]: 'Plano atualizado. Pro-rata cobrado agora.',
  [tokens.pages.billing.snackbar.updated]: 'Assinatura atualizada',
  [tokens.pages.billing.snackbar.changeError]: 'Falha ao alterar plano',
  [tokens.pages.billing.snackbar.updateCardHint]: 'Atualize o cartão no portal e tente de novo.',
  [tokens.pages.billing.customBanner.name]: 'Customizado',
  [tokens.pages.billing.customBanner.body]:
    'Solução sob medida: funcionalidades exclusivas sob demanda, integrações customizadas, contrato e SLA personalizado, gerente de conta dedicado.',
  [tokens.pages.billing.tier.starter.tagline]: 'Comece sem custo fixo',
  [tokens.pages.billing.tier.starter.h1]: 'Cardápio digital ilimitado',
  [tokens.pages.billing.tier.starter.h2]: 'Pré-pago (paga ao pedir)',
  [tokens.pages.billing.tier.starter.h3]: 'Pagamento: cartão e PIX',
  [tokens.pages.billing.tier.starter.h4]: 'Pedidos em tempo real',
  [tokens.pages.billing.tier.starter.h5]: '1 cardápio ativo',
  [tokens.pages.billing.tier.starter.h6]: '1 estabelecimento',
  [tokens.pages.billing.tier.starter.h7]: 'Suporte por e-mail',
  [tokens.pages.billing.tier.essential.tagline]: 'Para quem quer profissionalizar a operação',
  [tokens.pages.billing.tier.essential.h1]: 'Tudo do Starter',
  [tokens.pages.billing.tier.essential.h2]: 'QR Code por mesa',
  [tokens.pages.billing.tier.essential.h3]: 'Múltiplos cardápios',
  [tokens.pages.billing.tier.essential.h4]: 'Relatórios e histórico',
  [tokens.pages.billing.tier.essential.h5]: '1 estabelecimento',
  [tokens.pages.billing.tier.essential.h6]: 'Suporte por chat',
  [tokens.pages.billing.tier.pro.tagline]: 'Para quem opera com seriedade',
  [tokens.pages.billing.tier.pro.h1]: 'Tudo do Essential',
  [tokens.pages.billing.tier.pro.h2]: 'Pós-pago / comanda',
  [tokens.pages.billing.tier.pro.h3]: 'Descontos e promoções',
  [tokens.pages.billing.tier.pro.h4]: 'Estoque básico',
  [tokens.pages.billing.tier.pro.h5]: 'Upsell por IA',
  [tokens.pages.billing.tier.pro.h6]: 'Relatórios e histórico',
  [tokens.pages.billing.tier.pro.h7]: 'Exportação CSV',
  [tokens.pages.billing.tier.pro.h8]: 'Customização visual',
  [tokens.pages.billing.tier.pro.h9]: 'Até 3 estabelecimentos',
  [tokens.pages.billing.tier.pro.h10]: 'Suporte prioritário',
  [tokens.pages.billing.tier.enterprise.tagline]: 'Redes e grandes operações',
  [tokens.pages.billing.tier.enterprise.h1]: 'Tudo do Pro',
  [tokens.pages.billing.tier.enterprise.h2]: 'Cardápio de rede',
  [tokens.pages.billing.tier.enterprise.h3]: 'Preços por unidade',
  [tokens.pages.billing.tier.enterprise.h4]: 'Estoque e perdas avançado',
  [tokens.pages.billing.tier.enterprise.h5]: 'Insights automáticos',
  [tokens.pages.billing.tier.enterprise.h6]: 'Previsão de demanda por IA',
  [tokens.pages.billing.tier.enterprise.h7]: 'Multi-unidade',
  [tokens.pages.billing.tier.enterprise.h8]: 'Dashboard de rede',
  [tokens.pages.billing.tier.enterprise.h9]: 'API PDV/ERP',
  [tokens.pages.billing.tier.enterprise.h10]: 'Até 10 estabelecimentos',
  [tokens.pages.billing.tier.enterprise.h11]: 'Onboarding assistido + SLA dedicado',
  [tokens.pages.billing.tier.custom.name]: 'Customizado',
  [tokens.pages.billing.tier.custom.tagline]: 'Solução sob medida para o seu negócio',
};

export default br;
